import { Store } from '@ngrx/store';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { interval, Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { Capacitor } from '@capacitor/core';

import * as fromAssetActions from 'app/core/store/actions/delivery-assets.actions';
import { TrackTypes } from 'app/core/models';
import { PlatformService } from 'app/core/services/platform.service';

@Pipe({
  standalone: false,
  name: 'media',
})
export class MediaPipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private store: Store<any>,
    private platformService: PlatformService,
  ) {}

  transform(types: TrackTypes[], mediaType: string): Observable<SafeUrl> {
    const localItem = types.find((type: any) => type && type.url && type.url.includes('file://'));

    if (localItem) {
      this.store.dispatch(fromAssetActions.SetReadyForPlaying({ payload: true }));
      const url = this.platformService.isIosApp()
        ? localItem.url.replace('file:///', '/')
        : localItem.url;

      return of(
        this.sanitizer.bypassSecurityTrustResourceUrl(
          this.platformService.isIosApp()
            ? url
            : Capacitor.convertFileSrc(url).replace('undefined/', ''),
        ),
      );
    }

    const item = types.find((type: any) => type && type.url.includes('stream'));


    if (item && item.url) {
      if (mediaType === 'video') {
        return timer(0, 45000).pipe(// 60000 milliseconds = 1 minute
          switchMap(() => this.http.get(item.url, { responseType: 'text' })),
          map((link: string) => link),
          tap(() => {
            this.store.dispatch(fromAssetActions.SetReadyForPlaying({ payload: true }));
          }),
        );
      } else {
        return this.http.get(item.url, { responseType: 'text' }).pipe(
          map((link: string) => this.sanitizer.bypassSecurityTrustUrl(link)),
          tap(() => {
            this.store.dispatch(fromAssetActions.SetReadyForPlaying({ payload: true }));
          }),
          catchError(() => {
            this.store.dispatch(fromAssetActions.SetReadyForPlaying({ payload: false }));
            this.store.dispatch(fromAssetActions.TogglePlaying({ payload: { play: false } }));
            return of('');
          }),
        );
      }
    }

    return of('');
  }
}
